import Loadable from '../../components/loadable';

const TrainerPayrollReport = Loadable({
  loader: () => import('../../pages/reports/trainer_payroll_report/trainer_payroll_report'),
});

angular.module('gym').value('TrainerPayrollReport', TrainerPayrollReport);

const TrainerPayrollReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/trainer_payroll_report/trainer_payroll_report_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('TrainerPayrollReportFiltersModal', TrainerPayrollReportFiltersModal);
